/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiGetBlob } from './common/api';
import endpoints from 'src/shared/service/endpoint/endpoints.class';
import { manageApiError } from './common/api.lib';

// Get UI configuration
export const apiGetBlobQrCode = (): Promise<any> => {
  const endpointClass = endpoints.ui.getQrCode;
  return apiGetBlob(endpointClass.getUrl(), {
    publicApi: endpointClass.isPublic(),
  })
    .then((response: any) => response)
    .catch((error: ErrorConstructor) =>
      manageApiError(error, 'apiGetBlobQrCode'),
    );
};
